/**
 *
 * @param decorationContract
 */
export function getBackdropAvatarId(decorationContract) {
    return decorationContract.backdropAvatarId;
}
/**
 *
 * @param decorationContract
 */
export function getBackdropAvatarUrl(decorationContract) {
    return decorationContract.backdropAvatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getLargeBackdropAvatarId(decorationContract) {
    return decorationContract.largeBackdropAvatarId;
}
/**
 *
 * @param decorationContract
 */
export function getLargeBackdropAvatarUrl(decorationContract) {
    return decorationContract.largeBackdropAvatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getSmallBackdropAvatarId(decorationContract) {
    return decorationContract.smallBackdropAvatarId;
}
/**
 *
 * @param decorationContract
 */
export function getSmallBackdropAvatarUrl(decorationContract) {
    return decorationContract.smallBackdropAvatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getThumbnailBackdropAvatarId(decorationContract) {
    return decorationContract.thumbnailBackdropAvatarId;
}
/**
 *
 * @param decorationContract
 */
export function getThumbnailBackdropAvatarUrl(decorationContract) {
    return decorationContract.thumbnailBackdropAvatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getDefaultBackdrop(decorationContract) {
    return decorationContract.defaultBackdrop;
}
/**
 *
 * @param decorationContract
 */
export function getAvatarUrl(decorationContract) {
    return decorationContract.avatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getFrameAvatarUrl(decorationContract) {
    return decorationContract.frameAvatarUrl;
}
/**
 *
 * @param decorationContract
 */
export function getAvatarId(decorationContract) {
    return decorationContract.avatarId;
}
/**
 *
 * @param decorationContract
 */
export function getPortraitDecorationKey(decorationContract) {
    return decorationContract.portraitDecorationKey;
}
/**
 *
 * @param decorationContract
 */
export function getFrameAvatarDecorationKey(decorationContract) {
    return decorationContract.frameAvatarDecorationKey;
}
/**
 *
 * @param decorationContract
 */
export function getFrameAvatarId(decorationContract) {
    return decorationContract.frameAvatarId;
}
/**
 *
 * @param decorationContract
 */
export function getThemeColor(decorationContract) {
    return decorationContract.themeColor;
}
/**
 *
 * @param decorationInfo
 */
export function getAvatarInfo(decorationInfo) {
    return decorationInfo.avatarInfo;
}
/**
 *
 * @param decorationInfo
 */
export function getCharacterTheme(decorationInfo) {
    return decorationInfo.characterTheme;
}
/**
 *
 * @param decorationInfo
 */
export function getBackdropInfo(decorationInfo) {
    return decorationInfo.backdropInfo;
}
